// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from '../../../../../shared/common/menu-items';
import { useStore } from '../../../../../stores/store';
import { observer } from 'mobx-react-lite';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = observer(() => {
  const { commonStore } = useStore();
  const roleName = commonStore.user?.data?.admin?.role?.roleName;

  const navGroups = menuItem.items.map((item: any) => {
    // Clone the item to avoid mutating the original menu items object
    const filteredItem = { ...item };

    if (filteredItem.children) {
      filteredItem.children = filteredItem.children.filter((child: any) => {
        if (child.id === 'customers' && roleName === 'Super KAM' ) {
          return false;
        }
        return true;
      });
    }

    switch (filteredItem.type) {
      case 'group':
        return <NavGroup key={filteredItem.id} item={filteredItem} />;
      default:
        return (
          <Typography key={filteredItem.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
});

export default Navigation;
